<template>
  <div>
    <div class="search-all">
      <el-checkbox
        v-model="checkAll"
      >
        群体分析
      </el-checkbox>
      <div v-if="checkAll" class="search-box mt20">
        <div v-if="classShow" class="row flex">
          <div class="label flex-center class">班级</div>
          <div class="row-con">
            <div v-if="classList.length > 0">
              <div v-for="(v, index) in classList" :key="index" class="flex">
                <div class="class-label flex items-c">
                  <div class="check-all">
                    <el-checkbox
                      v-model="v.checkAll"
                      @change="handleCheckAllClassChange($event, index)"
                    >
                      {{ v.name }}
                    </el-checkbox>
                  </div>
                </div>
                <div class="row-con flex items-c class-check-box">
                  <el-checkbox-group v-model="v.ids" @change="idsChange(index)">
                    <el-checkbox
                      v-for="(q, qIndex) in v.classrooms"
                      :key="qIndex"
                      :label="q.id"
                    >
                      {{ q.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row flex">
          <div class="label flex-center">性别</div>
          <div class="row-con flex items-c">
            <el-checkbox-group v-model="searchParams.sexes" :min="1">
              <el-checkbox
                v-for="item in $enums.gender"
                :key="item.code"
                :label="item.code"
              >
                {{ item.description }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="row flex">
          <div class="label flex-center">年龄</div>
          <div class="row-con flex items-c">
            <el-checkbox
              v-model="checkAllAge"
              @change="handleCheckAllAgeChange"
            >
              全选
            </el-checkbox>

            <el-checkbox-group
              v-model="searchParams.ageRangeTypes"
              class="ml20"
              @change="handleAgeCheckedChange"
            >
              <el-checkbox
                v-for="item in $enums.groupAnalysisAgeType"
                :key="item.code"
                :label="item.code"
              >
                {{ item.description }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>

        <div class="row flex no-border">
          <div class="label flex-center">月龄</div>
          <div class="row-con flex items-c">
            <el-row style="width: 800px">
              <el-col :span="4">
                <el-input
                  v-model="searchParams.monthAgeFromTime"
                  size="small"
                  placeholder="请输入整数"
                />
              </el-col>
              <el-col :span="1">
                <div class="text-center age-unit">
                  月-
                </div>
              </el-col>
              <el-col :span="4">
                <el-input
                  v-model="searchParams.monthAgeToTime"
                  size="small"
                  placeholder="请输入整数"
                />
              </el-col>
              <el-col :span="1">
                <div class="text-center age-unit">
                  月
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div v-if="pdfShow" class="report-pdf">
      <div id="Page1Pdf1">
        <Page1Pdf1 :search-params="searchParams" />
      </div>
      <div id="Page1Pdf2">
        <Page1Pdf2 :search-params="searchParams" />
      </div>
      <div id="Page1Pdf3">
        <Page1Pdf3 :search-params="searchParams" />
      </div>
      <div id="Page1Pdf4">
        <Page1Pdf4 :search-params="searchParams" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  getClassList
} from '@/api/teachingProtection/assessment'
import Page1Pdf1 from './Page1Pdf1'
import Page1Pdf2 from './Page1Pdf2'
import Page1Pdf3 from './Page1Pdf3'
import Page1Pdf4 from './Page1Pdf4'

export default {
  components: {
    Page1Pdf1,
    Page1Pdf2,
    Page1Pdf3,
    Page1Pdf4
  },
  props: {
    params: {}
  },
  data() {
    return {
      classList: [],
      classShow: true,
      searchParams: {
        sexes: [101, 102],
        classroomIds: [],
        ageRangeTypes: [],
        year: '',
        semesterType: '',
        periodType: '',
        tabPosition: '',
        monthAgeFromTime: null,
        monthAgeToTime: null
      },
      checkAllAge: false,
      checkAll: true,
      pdfShow: false
    }
  },
  created() {
    getClassList().then((res) => {
      this.classList = res.data.array.filter((v) => {
        return v.name !== '其他'
      })
      this.classList.map((v, index) => {
        v.ids = []
        let checkedCount = this.classList[index].ids.length
        this.classList[index].checkAll =
            checkedCount === this.classList[index].classrooms.length
      })
    })
  },
  mounted() {
    this.searchParams.year = this.params.year
    this.searchParams.semesterType = this.params.semesterType
    this.searchParams.periodType = this.params.periodType
  },
  methods: {
    idsChange(index) {
      this.classShow = false
      this.$nextTick(() => {
        this.classShow = true
        let checkedCount = this.classList[index].ids.length
        this.classList[index].checkAll =
          checkedCount === this.classList[index].classrooms.length
      })
      this.resetClassroomIds()
    },
    handleCheckAllAgeChange(val) {
      const arr = []
      this.$enums.groupAnalysisAgeType.map((v) => {
        arr.push(v.code)
      })
      if (val) {
        this.searchParams.ageRangeTypes = arr
      } else {
        this.searchParams.ageRangeTypes = []
      }
    },
    handleAgeCheckedChange(val) {
      let checkedCount = val.length
      this.checkAllAge =
        checkedCount === this.$enums.groupAnalysisAgeType.length
    },
    handleCheckAllClassChange(val, index) {
      const arr = []
      this.classList[index].classrooms.map((v) => {
        arr.push(v.id)
      })
      if (val) {
        this.classList[index].ids = arr
      } else {
        this.classList[index].ids = []
      }
      this.classShow = false
      this.$nextTick(() => {
        this.classShow = true
      })
      this.resetClassroomIds()
    },
    resetClassroomIds() {
      const arr = []
      this.classList.map((v) => {
        v.ids.map((q) => {
          arr.push(q)
        })
      })
      this.searchParams.classroomIds = arr
    },
    download() {
      this.pdfShow = true
    }
  }
}
</script>
<style lang="scss" scoped>
.down-btn{
  width: 120px;
}
.search-all{
  border: 1px solid #EFEFEF;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 4px 4px 8px 0px rgba(153,153,153,0.11);
}
.search-box {
  border: 1px solid #e8edf2;
  .row {
    border-bottom: 1px solid #e8edf2;
    .label {
      background: #f5f7fa;
      width: 60px;
      min-height: 36px;
    }
    .class {
      min-height: 85px !important;
    }
    .row-con {
      padding: 10px 20px;
      width: 100%;
    }
    .check-all {
      margin: 5px 0;
    }
  }
}
.age-unit{
  line-height: 30px;
}
</style>
